import { functions } from '../utils/firebase';

export const getExplorerHistory = params => {
  return functions.httpsCallable('RiskModule-explorerHistory')({
    body: params,
  });
};
